<template>
  <div>
    <human-body-female-front-muscles
      v-if="gender === 'female'"
      :style="{ 'height': height + 'px', 'width': width + 'px' }"
      :stats="playerStats"
      :stats-suffix="statsSuffix"
      :interactive="interactive"
      @click="$emit('click', $event)"
    />
    <human-body-front-muscles
      v-else
      class="mx-3"
      :style="{ 'height': height + 'px', 'width': width + 'px' }"
      :stats="playerStats"
      :stats-suffix="statsSuffix"
      :interactive="interactive"
      @click="$emit('click', $event)"
    />
    <human-body-female-back-muscles
      v-if="gender === 'female'"
      class="mx-3"
      :style="{ 'height': height + 'px', 'width': width + 'px' }"
      :stats="playerStats"
      :stats-suffix="statsSuffix"
      :interactive="interactive"
      @click="$emit('click', $event)"
    />
    <human-body-back-muscles
      v-else
      class="mx-3"
      :style="{ 'height': height + 'px', 'width': width + 'px' }"
      :stats="playerStats"
      :stats-suffix="statsSuffix"
      :interactive="interactive"
      @click="$emit('click', $event)"
    />
  </div>
</template>
<script>
import HumanBodyFrontMuscles from '@/components/human-body/HumanBodyFrontMuscles.vue'
import HumanBodyBackMuscles from '@/components/human-body/HumanBodyBackMuscles.vue'
import HumanBodyFemaleFrontMuscles from '@/components/human-body/HumanBodyFemaleFrontMuscles.vue'
import HumanBodyFemaleBackMuscles from '@/components/human-body/HumanBodyFemaleBackMuscles.vue'

export default {
  name: 'PainAvatarGroup',
  components: { HumanBodyFemaleBackMuscles, HumanBodyFemaleFrontMuscles, HumanBodyBackMuscles, HumanBodyFrontMuscles },
  props: {
    width: {
      type: Number,
      default: 130
    },
    height: {
      type: Number,
      default: 205
    },
    playerStats: {
      type: [Object, Array],
      default: () => ({})
    },
    gender: {
      type: String,
      default: 'male'
    },
    interactive: {
      type: Boolean,
      default: false
    },
    statsSuffix: {
      type: String,
      default: '_DL'
    }
  }
}
</script>
